// extracted by mini-css-extract-plugin
module.exports = {"quantityInputItem":"QuantityInputItem_quantityInputItem__nJ9z8"};